export interface IResponsibilityImportExcelDefinition {
  columns: IResponsibilityImportExcelColumnConfig[];
  qnColumns: IResponsibilityImportExcelColumnConfig[];
  planColumns: IResponsibilityImportExcelColumnConfig[];
  accColumns: IResponsibilityImportExcelColumnConfig[];
  invColumns: IResponsibilityImportExcelColumnConfig[];
}

export interface IResponsibilityImportData {
  responsibilityId: number | undefined;
  companyName: string;
  programName: string;
  category: string;
  brandNames: string;
  customerIds: string;

  salesGroup1: string;
  salesGroup2: string;
  salesGroup3: string;

  salesTeam1: string;
  salesTeam2: string;
  salesTeam3: string;

  salesName1: string;
  salesName2: string;
  salesName3: string;

  salesNameStatus1: string;
  salesNameStatus2: string;
  salesNameStatus3: string;

  ssoGroup1: string;
  ssoGroup2: string;
  ssoGroup3: string;
  ssoGroup4: string;

  ssoTeam1: string;
  ssoTeam2: string;
  ssoTeam3: string;
  ssoTeam4: string;

  ssoName1: string;
  ssoName2: string;
  ssoName3: string;
  ssoName4: string;

  ssoNameStatus1: string;
  ssoNameStatus2: string;
  ssoNameStatus3: string;
  ssoNameStatus4: string;

  csGroup1: string;
  csGroup2: string;
  csGroup3: string;
  csGroup4: string;
  csGroup5: string;

  csTeam1: string;
  csTeam2: string;
  csTeam3: string;
  csTeam4: string;
  csTeam5: string;

  csName1: string;
  csName2: string;
  csName3: string;
  csName4: string;
  csName5: string;

  csNameStatus1: string;
  csNameStatus2: string;
  csNameStatus3: string;
  csNameStatus4: string;
  csNameStatus5: string;

  npdHLName1: string;
  npdHLName2: string;
  npdHLName3: string;

  npdPLName1: string;
  npdPLName2: string;
  npdPLName3: string;

  npdNLName1: string;
  npdNLName2: string;
  npdNLName3: string;

  npdTLName1: string;
  npdTLName2: string;
  npdTLName3: string;

  npdWLName1: string;
  npdWLName2: string;
  npdWLName3: string;

  npdHLNameStatus1: string;
  npdHLNameStatus2: string;
  npdHLNameStatus3: string;

  npdPLNameStatus1: string;
  npdPLNameStatus2: string;
  npdPLNameStatus3: string;

  npdNLNameStatus1: string;
  npdNLNameStatus2: string;
  npdNLNameStatus3: string;

  npdTLNameStatus1: string;
  npdTLNameStatus2: string;
  npdTLNameStatus3: string;

  npdWLNameStatus1: string;
  npdWLNameStatus2: string;
  npdWLNameStatus3: string;

  entryName1: string;
  entryName2: string;
  entryName3: string;

  entryNameStatus1: string;
  entryNameStatus2: string;
  entryNameStatus3: string;
}

export interface IResponsibilityImportExcelColumnConfig {
  propertyName: string;
  caption: string;
  excelIndex: number | null;
}

export type IExcelRow = string[];

export const config: IResponsibilityImportExcelDefinition = {
  columns: [
    {
      propertyName: 'responsibilityId',
      caption: 'Responsibility ID',
      excelIndex: 1,
    },
    {
      propertyName: 'companyName',
      caption: 'Company',
      excelIndex: 8,
    },
    {
      propertyName: 'programName',
      caption: 'Program',
      excelIndex: 9,
    },
    {
      propertyName: 'Category',
      caption: 'Category',
      excelIndex: 10,
    },
    {
      propertyName: 'brandNames',
      caption: 'Brand Names',
      excelIndex: 11,
    },
    {
      propertyName: 'customerIds',
      caption: 'Customer IDs',
      excelIndex: 12,
    },
    //#region Sales
    {
      propertyName: 'salesGroup1',
      caption: 'Sales Group 1',
      excelIndex: 13,
    },
    {
      propertyName: 'salesTeam1',
      caption: 'Sales Team 1',
      excelIndex: 15,
    },
    {
      propertyName: 'salesName1',
      caption: 'Sales Name 1',
      excelIndex: 16,
    },
    {
      propertyName: 'salesNameStatus1',
      caption: 'Sales Name Status 1',
      excelIndex: 17,
    },
    {
      propertyName: 'salesGroup2',
      caption: 'Sales Group 2',
      excelIndex: 13,
    },
    {
      propertyName: 'salesTeam2',
      caption: 'Sales Team 2',
      excelIndex: 15,
    },
    {
      propertyName: 'salesName2',
      caption: 'Sales Name 2',
      excelIndex: 18,
    },
    {
      propertyName: 'salesNameStatus2',
      caption: 'Sales Name Status 2',
      excelIndex: 19,
    },
    {
      propertyName: 'salesGroup3',
      caption: 'Sales Group 3',
      excelIndex: 13,
    },
    {
      propertyName: 'salesTeam3',
      caption: 'Sales Team 3',
      excelIndex: 15,
    },
    {
      propertyName: 'salesName3',
      caption: 'Sales Name 3',
      excelIndex: 20,
    },
    {
      propertyName: 'salesNameStatus3',
      caption: 'Sales Name Status 3',
      excelIndex: 21,
    },
    //#endregion

    //#region SSO1
    {
      propertyName: 'ssoGroup1',
      caption: 'SSO Group 1',
      excelIndex: 22,
    },
    {
      propertyName: 'ssoTeam1',
      caption: 'SSO Team 1',
      excelIndex: 23,
    },
    {
      propertyName: 'ssoName1',
      caption: 'SSO Name 1',
      excelIndex: 25,
    },
    {
      propertyName: 'ssoNameStatus1',
      caption: 'SSO Name Status 1',
      excelIndex: 26,
    },
    //#endregion

    //#region SSO2
    {
      propertyName: 'ssoGroup2',
      caption: 'SSO Group 2',
      excelIndex: 22,
    },
    {
      propertyName: 'ssoTeam2',
      caption: 'SSO Team 2',
      excelIndex: 23,
    },
    {
      propertyName: 'ssoName2',
      caption: 'SSO Name 2',
      excelIndex: 27,
    },
    {
      propertyName: 'ssoNameStatus2',
      caption: 'SSO Name Status 2',
      excelIndex: 28,
    },
    //#endregion

    //#region SSO3
    {
      propertyName: 'ssoGroup3',
      caption: 'SSO Group 3',
      excelIndex: 22,
    },
    {
      propertyName: 'ssoTeam3',
      caption: 'SSO Team 3',
      excelIndex: 23,
    },
    {
      propertyName: 'ssoName3',
      caption: 'SSO Name 3',
      excelIndex: 29,
    },
    {
      propertyName: 'ssoNameStatus3',
      caption: 'SSO Name Status 3',
      excelIndex: 30,
    },
    //#endregion

    //#region SSO4
    {
      propertyName: 'ssoGroup4',
      caption: 'SSO Group 4',
      excelIndex: 22,
    },
    {
      propertyName: 'ssoTeam4',
      caption: 'SSO Team 4',
      excelIndex: 23,
    },
    {
      propertyName: 'ssoName4',
      caption: 'SSO Name 4',
      excelIndex: 31,
    },
    {
      propertyName: 'ssoNameStatus4',
      caption: 'SSO Name Status 4',
      excelIndex: 32,
    },
    //#endregion

    //#region CS1
    {
      propertyName: 'csGroup1',
      caption: 'CS Group 1',
      excelIndex: 33,
    },
    {
      propertyName: 'csTeam1',
      caption: 'CS Team 1',
      excelIndex: 34,
    },
    {
      propertyName: 'csName1',
      caption: 'CS Name 1',
      excelIndex: 36,
    },
    {
      propertyName: 'csNameStatus1',
      caption: 'CS Name Status 1',
      excelIndex: 37,
    },
    //#endregion

    //#region CS2
    {
      propertyName: 'csGroup2',
      caption: 'CS Group 2',
      excelIndex: 33,
    },
    {
      propertyName: 'csTeam2',
      caption: 'CS Team 2',
      excelIndex: 34,
    },
    {
      propertyName: 'csName2',
      caption: 'CS Name 2',
      excelIndex: 38,
    },
    {
      propertyName: 'csNameStatus2',
      caption: 'CS Name Status 2',
      excelIndex: 39,
    },
    //#endregion

    //#region CS3
    {
      propertyName: 'csGroup3',
      caption: 'CS Group 3',
      excelIndex: 33,
    },
    {
      propertyName: 'csTeam3',
      caption: 'CS Team 3',
      excelIndex: 34,
    },
    {
      propertyName: 'csName3',
      caption: 'CS Name 3',
      excelIndex: 40,
    },
    {
      propertyName: 'csNameStatus3',
      caption: 'CS Name Status 3',
      excelIndex: 41,
    },
    //#endregion

    //#region CS4
    {
      propertyName: 'csGroup4',
      caption: 'CS Group 4',
      excelIndex: 33,
    },
    {
      propertyName: 'csTeam4',
      caption: 'CS Team 4',
      excelIndex: 34,
    },
    {
      propertyName: 'csName4',
      caption: 'CS Name 4',
      excelIndex: 42,
    },
    {
      propertyName: 'csNameStatus4',
      caption: 'CS Name Status 4',
      excelIndex: 43,
    },
    //#endregion

    //#region CS5
    {
      propertyName: 'csGroup5',
      caption: 'CS Group 5',
      excelIndex: 33,
    },
    {
      propertyName: 'csTeam5',
      caption: 'CS Team 5',
      excelIndex: 34,
    },
    {
      propertyName: 'csName5',
      caption: 'CS Name 5',
      excelIndex: 44,
    },
    {
      propertyName: 'csNameStatus5',
      caption: 'CS Name Status 5',
      excelIndex: 45,
    },
    //#endregion

    //#region NPD HL
    {
      propertyName: 'npdHLTeam',
      caption: 'NPD HL Team',
      excelIndex: 46,
    },
    {
      propertyName: 'npdHLName1',
      caption: 'NPD HL Name 1',
      excelIndex: 47,
    },
    {
      propertyName: 'npdHLNameStatus1',
      caption: 'NPD HL Status 1',
      excelIndex: 48,
    },
    {
      propertyName: 'npdHLName2',
      caption: 'NPD HL Name 2',
      excelIndex: 49,
    },
    {
      propertyName: 'npdHLNameStatus2',
      caption: 'NPD HL Status 2',
      excelIndex: 50,
    },
    {
      propertyName: 'npdHLName3',
      caption: 'NPD HL Name 3',
      excelIndex: 51,
    },
    {
      propertyName: 'npdHLNameStatus3',
      caption: 'NPD HL Status 3',
      excelIndex: 52,
    },
    //#endregion

    //#region NPD PL
    {
      propertyName: 'npdPLTeam',
      caption: 'NPD PL Team',
      excelIndex: 53,
    },
    {
      propertyName: 'npdPLName1',
      caption: 'NPD PL Name 1',
      excelIndex: 54,
    },
    {
      propertyName: 'npdPLNameStatus1',
      caption: 'NPD PL Status 1',
      excelIndex: 55,
    },
    {
      propertyName: 'npdPLName2',
      caption: 'NPD PL Name 2',
      excelIndex: 56,
    },
    {
      propertyName: 'npdPLNameStatus2',
      caption: 'NPD HL Status 2',
      excelIndex: 57,
    },
    {
      propertyName: 'npdPLName3',
      caption: 'NPD PL Name 3',
      excelIndex: 58,
    },
    {
      propertyName: 'npdPLNameStatus3',
      caption: 'NPD HL Status 3',
      excelIndex: 59,
    },
    //#endregion

    //#region NPD NL
    {
      propertyName: 'npdNLTeam',
      caption: 'NPD NL Team',
      excelIndex: 60,
    },
    {
      propertyName: 'npdNLName1',
      caption: 'NPD NL Name 1',
      excelIndex: 61,
    },
    {
      propertyName: 'npdNLNameStatus1',
      caption: 'NPD NL Status 1',
      excelIndex: 62,
    },
    {
      propertyName: 'npdNLName2',
      caption: 'NPD NL Name 2',
      excelIndex: 63,
    },
    {
      propertyName: 'npdNLNameStatus2',
      caption: 'NPD NL Status 2',
      excelIndex: 64,
    },
    {
      propertyName: 'npdNLName3',
      caption: 'NPD NL Name 3',
      excelIndex: 65,
    },
    {
      propertyName: 'npdNLNameStatus3',
      caption: 'NPD NL Status 3',
      excelIndex: 66,
    },
    //#endregion

    //#region NPD TL
    {
      propertyName: 'npdTLTeam',
      caption: 'NPD TL Team',
      excelIndex: 67,
    },
    {
      propertyName: 'npdTLName1',
      caption: 'NPD TL Name 1',
      excelIndex: 68,
    },
    {
      propertyName: 'npdTLNameStatus1',
      caption: 'NPD TL Status 1',
      excelIndex: 69,
    },
    {
      propertyName: 'npdTLName2',
      caption: 'NPD TL Name 2',
      excelIndex: 70,
    },
    {
      propertyName: 'npdTLNameStatus2',
      caption: 'NPD TL Status 2',
      excelIndex: 71,
    },
    {
      propertyName: 'npdTLName3',
      caption: 'NPD TL Name 3',
      excelIndex: 72,
    },
    {
      propertyName: 'npdTLNameStatus3',
      caption: 'NPD TL Status 3',
      excelIndex: 73,
    },
    //#endregion

    //#region NPD WL
    {
      propertyName: 'npdWLTeam',
      caption: 'NPD WL Team',
      excelIndex: 74,
    },
    {
      propertyName: 'npdWLName1',
      caption: 'NPD WL Name 1',
      excelIndex: 75,
    },
    {
      propertyName: 'npdWLNameStatus1',
      caption: 'NPD WL Status 1',
      excelIndex: 76,
    },
    {
      propertyName: 'npdWLName2',
      caption: 'NPD WL Name 2',
      excelIndex: 77,
    },
    {
      propertyName: 'npdWLNameStatus2',
      caption: 'NPD WL Status 2',
      excelIndex: 78,
    },
    {
      propertyName: 'npdWLName3',
      caption: 'NPD WL Name 3',
      excelIndex: 79,
    },
    {
      propertyName: 'npdWLNameStatus3',
      caption: 'NPD WL Status 3',
      excelIndex: 80,
    },
    //#endregion

    //#region NPD FLEXIBLE
    {
      propertyName: 'npdFlexibleTeam',
      caption: 'NPD Flexible Team',
      excelIndex: 81,
    },
    {
      propertyName: 'npdFlexibleName1',
      caption: 'NPD Flexible Name 1',
      excelIndex: 82,
    },
    {
      propertyName: 'npdFlexibleNameStatus1',
      caption: 'NPD Flexible Status 1',
      excelIndex: 83,
    },
    {
      propertyName: 'npdFlexibleName2',
      caption: 'NPD Flexible Name 2',
      excelIndex: 84,
    },
    {
      propertyName: 'npdFlexibleNameStatus2',
      caption: 'NPD Flexible Status 2',
      excelIndex: 85,
    },
    {
      propertyName: 'npdFlexibleName3',
      caption: 'NPD Flexible Name 3',
      excelIndex: 86,
    },
    {
      propertyName: 'npdFlexibleNameStatus3',
      caption: 'NPD Flexible Status 3',
      excelIndex: 87,
    },
    //#endredion

    //#region Data Entry
    {
      propertyName: 'entryTeam',
      caption: 'Entry Team',
      excelIndex: 88,
    },
    {
      propertyName: 'entryName1',
      caption: 'Entry Name 1',
      excelIndex: 89,
    },
    {
      propertyName: 'entryNameStatus1',
      caption: 'Entry Name Status 1',
      excelIndex: 90,
    },
    {
      propertyName: 'entryName2',
      caption: 'Entry Name 2',
      excelIndex: 91,
    },
    {
      propertyName: 'entryNameStatus2',
      caption: 'Entry Name Status 2',
      excelIndex: 92,
    },
    {
      propertyName: 'entryName3',
      caption: 'Entry Name 3',
      excelIndex: 93,
    },
    {
      propertyName: 'entryNameStatus3',
      caption: 'Entry Name Status 3',
      excelIndex: 94,
    },
    //#endregion
  ],
  qnColumns: [
    {
      propertyName: 'responsibilityId',
      caption: 'Responsibility ID',
      excelIndex: 1,
    },
    {
      propertyName: 'companyName',
      caption: 'Company',
      excelIndex: 8,
    },
    {
      propertyName: 'programName',
      caption: 'Program',
      excelIndex: 9,
    },
    {
      propertyName: 'qngroup',
      caption: 'QN Group',
      excelIndex: 10,
    },
    {
      propertyName: 'qnTeam',
      caption: 'QN Team',
      excelIndex: 11,
    },
    //#region QN1
    {
      propertyName: 'qnName1',
      caption: 'QN Name 1',
      excelIndex: 12,
    },
    {
      propertyName: 'qnNameStatus1',
      caption: 'QN Status 1',
      excelIndex: 13,
    },
    //#endregion

    //#region QN2
    {
      propertyName: 'qnName2',
      caption: 'QN Name 2',
      excelIndex: 14,
    },
    {
      propertyName: 'qnNameStatus2',
      caption: 'QN Status 2',
      excelIndex: 15,
    },
    //#endregion

    //#region QN3
    {
      propertyName: 'qnName3',
      caption: 'QN Name 3',
      excelIndex: 16,
    },
    {
      propertyName: 'qnNameStatus3',
      caption: 'QN Status 3',
      excelIndex: 17,
    },
    //#endregion
  ],
  planColumns: [
    {
      propertyName: 'responsibilityId',
      caption: 'Responsibility ID',
      excelIndex: 1,
    },
    {
      propertyName: 'companyName',
      caption: 'Company',
      excelIndex: 8,
    },
    {
      propertyName: 'programName',
      caption: 'Operation',
      excelIndex: 9,
    },
    {
      propertyName: 'brandNames',
      caption: 'Machine',
      excelIndex: 10,
    },
    {
      propertyName: 'planGroup',
      caption: 'Plan Group',
      excelIndex: 11,
    },
    {
      propertyName: 'planTeam',
      caption: 'Plan Team',
      excelIndex: 12,
    },
    //#region PLAN1
    {
      propertyName: 'planName1',
      caption: 'Plan Name 1',
      excelIndex: 13,
    },
    {
      propertyName: 'planNameStatus1',
      caption: 'Plan Name Status 1',
      excelIndex: 14,
    },
    //#endregion
    //#region PLAN2
    {
      propertyName: 'planName2',
      caption: 'Plan Name 2',
      excelIndex: 15,
    },
    {
      propertyName: 'planNameStatus2',
      caption: 'Plan Name Status 2',
      excelIndex: 16,
    },
    //#endregion
    //#region PLAN3
    {
      propertyName: 'planName3',
      caption: 'Plan Name 3',
      excelIndex: 17,
    },
    {
      propertyName: 'planNameStatus3',
      caption: 'Plan Name Status 3',
      excelIndex: 18,
    },
    //#endregion
  ],
  accColumns: [
    {
      propertyName: 'responsibilityId',
      caption: 'Responsibility ID',
      excelIndex: 1,
    },
    {
      propertyName: 'companyName',
      caption: 'Company',
      excelIndex: 8,
    },
    {
      propertyName: 'programName',
      caption: 'Program',
      excelIndex: 9,
    },
    {
      propertyName: 'accountGroup',
      caption: 'Account Group',
      excelIndex: 10,
    },
    {
      propertyName: 'accountTeam',
      caption: 'Account Team',
      excelIndex: 11,
    },
    //#region Account1
    {
      propertyName: 'accountName1',
      caption: 'Account Name 1',
      excelIndex: 12,
    },
    {
      propertyName: 'accountNameStatus1',
      caption: 'Account Status 1',
      excelIndex: 13,
    },
    //#endregion

    //#region Account2
    {
      propertyName: 'accountName2',
      caption: 'Account Name 2',
      excelIndex: 14,
    },
    {
      propertyName: 'accountNameStatus2',
      caption: 'Account Status 2',
      excelIndex: 15,
    },
    //#endregion

    //#region Account3
    {
      propertyName: 'accountName3',
      caption: 'Account Name 3',
      excelIndex: 16,
    },
    {
      propertyName: 'accountNameStatus3',
      caption: 'Account Status 3',
      excelIndex: 17,
    },
    //#endregion
  ],
  invColumns: [
    {
      propertyName: 'responsibilityId',
      caption: 'Responsibility ID',
      excelIndex: 1,
    },
    {
      propertyName: 'companyName',
      caption: 'Company',
      excelIndex: 8,
    },
    {
      propertyName: 'programName',
      caption: 'Program',
      excelIndex: 9,
    },
    {
      propertyName: 'logisticGroup',
      caption: 'Logistic Group',
      excelIndex: 10,
    },
    {
      propertyName: 'logisticTeam',
      caption: 'Logistic Team',
      excelIndex: 11,
    },
    //#region Account1
    {
      propertyName: 'logisticName1',
      caption: 'Logistic Name 1',
      excelIndex: 12,
    },
    {
      propertyName: 'logisticNameStatus1',
      caption: 'Logistic Status 1',
      excelIndex: 13,
    },
    //#endregion

    //#region Account2
    {
      propertyName: 'logisticName2',
      caption: 'Logistic Name 2',
      excelIndex: 14,
    },
    {
      propertyName: 'logisticNameStatus2',
      caption: 'Logistic Status 2',
      excelIndex: 15,
    },
    //#endregion

    //#region Account3
    {
      propertyName: 'LogisticName3',
      caption: 'Logistic Name 3',
      excelIndex: 16,
    },
    {
      propertyName: 'logisticNameStatus3',
      caption: 'Logistic Status 3',
      excelIndex: 17,
    },
    //#endregion
  ],
};
